import * as React from 'react';
import { cn } from '@/core/lib/utils';

interface SeveritySliderProps {
  value?: number;
  onChange?: (value: number) => void;
  disabled?: boolean;
  className?: string;
  min?: number;
  max?: number;
}

const severityLabels: Record<number, { label: string; color: string }> = {
  1: { label: 'Minimal', color: 'bg-green-500' },
  2: { label: 'Mild', color: 'bg-lime-500' },
  3: { label: 'Moderate', color: 'bg-yellow-500' },
  4: { label: 'Significant', color: 'bg-orange-500' },
  5: { label: 'Severe', color: 'bg-red-500' },
};

export function SeveritySlider({
  value = 1,
  onChange,
  disabled = false,
  className,
  min = 1,
  max = 5,
}: SeveritySliderProps) {
  const currentSeverity = severityLabels[value] || severityLabels[3];

  return (
    <div className={cn('space-y-2', className)}>
      <div className="flex justify-between items-center">
        <span className="text-sm font-medium">Severity</span>
        <span className={cn(
          'text-sm font-medium px-2 py-1 rounded',
          value <= 2 ? 'text-green-700 bg-green-100' :
          value === 3 ? 'text-yellow-700 bg-yellow-100' :
          'text-red-700 bg-red-100'
        )}>
          {currentSeverity.label}
        </span>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={(e) => onChange?.(parseInt(e.target.value, 10))}
        disabled={disabled}
        className={cn(
          'w-full h-2 rounded-lg appearance-none cursor-pointer',
          'bg-gray-200 accent-sage-600',
          disabled && 'opacity-50 cursor-not-allowed'
        )}
      />
      <div className="flex justify-between text-xs text-gray-500">
        <span>Minimal</span>
        <span>Severe</span>
      </div>
    </div>
  );
}

export default SeveritySlider;
